<template>
  <v-date-picker
    v-model="localValueDateObj"
    mode="date"
    :input-props="localOptions"
    :popover="{ visibility: 'focus' }"
    :keep-visible-on-input="false"
    :required="true"
    @input="updateValues"
  >
    <textbox-vee
      ref="dateValidation"
      v-model="localValue"
      slot-scope="{ inputEvents }"
      autocomplete="no"
      rules="required"
      v-bind="{ ...$props, ...$attrs }"
      v-on="{ ...inputEvents, ...inputListeners }"
    />
  </v-date-picker>
</template>
<script>
import Vue from 'vue';
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';
import VCalendar from 'v-calendar';
import 'v-calendar/src/styles/base.css';

Vue.use(VCalendar, {});

const TextboxVee = withValidation(Textbox);

export default {
  name: 'DatePicker',
  components: {
    TextboxVee,
  },
  props: {
    value: {
      type: [ String, Date ],
      default: () => {
        return {};
      },
      required: true,
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rules: {
      type: [ String, Array ],
      default: '',
    },
  },
  data () {
    return {
      localValue: '',
      localValueDateObj: null,
      localOptions: {
        class: 'input',
      },
    };
  },
  computed: {
    inputListeners: function () {
      return Object.assign({},
        this.$listeners,
        {
          input: this.updateValues(),
        },
      );
    },
  },
  watch: {
    // value: {
    //   deep: true,
    //   handler: function() {
    //     this.localValueDateObj = new Date(this.value);
    //   },
    // },
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.initialSet();
      }
    },
  },
  mounted () {
    this.localOptions = { ...this.localOptions, ...this.options };
    this.initialSet();
  },
  methods: {
    initialSet () {
      if (this.value !== '') {
        this.localValue = this.formatDate(this.value, 'MM/DD/YYYY');
      } else {
        this.localValue = this.value;
      }
    },
    updateValues () {
      if (this.localValueDateObj) {
        this.$refs['dateValidation'].validate();
        this.localValue = this.formatDate(this.localValueDateObj, 'MM/DD/YYYY');
        this.$emit('input', this.localValue);
      }
    },
  },
};
</script>